/*
 * Copyright (c), Onnorokom Web Services Ltd (OWSL) and/or its affiliates. All rights reserved.
 * OWSL PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import { getProductHtml } from './modules/home-product-module';
import { getDealProductHtml } from './modules/home-product-module';
import { getFrontListHtml } from './modules/front-list-module';
import { imageLazyLoading } from '../../common/js/lazy-loading';
import {superDealCountDownTimer} from '../../common/js/common'
import { setCookie, hasCookie, getCookie, deleteCookie } from 'common-js/cooke-util';
import { slickAdd } from './slick-desktop';
const PAGE_CONTEXT = $("meta[name='context-path']").attr('content');
const applicationProperties = require('../../../applicationProperties.json');
const IMG_FILE_PATH = applicationProperties.imgFilePath;
const PRODUCT_IMAGE_URL = applicationProperties.productImageUrl;
const BOOK_DEFAULT_IMAGE_URL = applicationProperties.bookDefaultImage;
const AUTHOR_IMAGE_URL = applicationProperties.authorImageUrl;
const PUBLISHER_IMAGE_URL = applicationProperties.publisherImageUrl;

$(document).on('click', '.rok-carousel .btn-next', event => {
    const carousel = $(event.target).closest('.rok-carousel');
    if (carousel.hasClass('initialized')) {
        return;
    }
    initialise(carousel);
    goNext(carousel);
});

$(document).on('click', '.rok-carousel .btn-next', event => goNext($(event.target).closest('.rok-carousel')));
$(document).on('click', '.rok-carousel .btn-prev', event => goPrevious($(event.target).closest('.rok-carousel')));

window.onresize = event => {
    $('.rok-carousel.initialized').each((index, carousel) => {
        reRender($(carousel), $(carousel).find('.book-list-wrapper:not(.filler)').clone());
    });
};

function initialise(carousel) {
    carousel.css('height', carousel.height());
    carousel.addClass('initialized');
    const frontListId = carousel.attr('id').split('-')[2];
    let products = [];

    if (frontListId === 'recentlySoldProducts') {
        recentlySoldProducts.forEach((productJson, index) => {
           products.push(getProductHtml(productJson, 0, `r_s${index}`, ));
        });
    } else {
        for(let i = 0; i < homePageFrontLists.length; i++) {
            if (homePageFrontLists[i].id === Number(frontListId)) {
                const frontList = homePageFrontLists[i];
                frontList.productShortViews.forEach((productJson, index) => {
                    let serial = 0;
                    if (frontList.id === 244 || frontList.id === 318
                        || frontList.type === 'WEB_HOME_SPECIAL' || frontList.type === 'WEB_AND_APP_HOME_SPECIAL') {
                        serial = frontList.productShortViews.length - index;
                    }
                    products.push(getProductHtml(productJson, serial, `fl${i}_p${index}`));
                });
                break;
            }
        }
    }

    reRender(carousel, products);
}

function reRender(carousel, products) {
    const productPerSlide = getProductPerSlide(carousel);
    const requiredSlide = Math.ceil(products.length / productPerSlide);
    let currentSlideIndex = Math.max(Math.min(carousel.find('.slide.current').index() - 1, requiredSlide - 1), 0);
    let maxHeight = carousel.height();

    if (products.length % requiredSlide > 0 && currentSlideIndex > 0) {
        currentSlideIndex--;
    }
    carousel.empty();
    carousel.append('<button class="btn-prev"></button>');
    for (let s = 0; s < requiredSlide; s++) {
        let slide;
        if (s === currentSlideIndex) {
            slide = $('<div class="slide current"></div>');
        } else if (s < currentSlideIndex) {
            slide = $('<div class="slide prev"></div>');
        } else {
            slide = $('<div class="slide next"></div>');
        }
        for(let i = 0; i < productPerSlide; i++) {
            const productIndex = i + s * productPerSlide;
            if(productIndex < products.length) {
                $(slide).append(products[productIndex]);
            } else {
                $(slide).append('<div class="book-list-wrapper filler"></div>');
            }
        }
        carousel.append(slide);
        const slideHeight = $(slide).height();
        if (slideHeight > maxHeight) {
            maxHeight = slideHeight;
        }
    }
    carousel.append('<button class="btn-next"></button>');
    carousel.css('height', maxHeight);

    updateButtonStatus(carousel);
}

function getProductPerSlide(carousel) {
    const clientWidth = document.documentElement.clientWidth;
    const largeScreenProductCount = Number(carousel.attr('lgs-count'));
    const mediumScreenProductCount = Number(carousel.attr('mds-count'));
    const smallScreenProductCount = Number(carousel.attr('sms-count'));
    const largeScreenLimit = 1400;
    const mediumScreenLimit = 1200;
    if (clientWidth >= largeScreenLimit) {
        return largeScreenProductCount;
    }
    if (clientWidth >= mediumScreenLimit) {
        return mediumScreenProductCount;
    }
    return smallScreenProductCount
}

function goNext(carousel) {
    const currentIndex = Math.max(carousel.find('.slide.current').index(), 1) + 1;
    const lastIndex = carousel.find('.btn-next').index() + 1;
    if (currentIndex === lastIndex - 1) {
        return;
    }
    const currentSlide = carousel.find('.slide:nth-child(' + currentIndex + ')');
    const nextSlide = carousel.find('.slide:nth-child(' + (currentIndex + 1) + ')');
    const fillerSize = nextSlide.find('.filler').length;
    if (fillerSize) {
        const productSize = nextSlide.find('.book-list-wrapper').length;
        const leftPercentage = fillerSize / productSize * 100;
        currentSlide.css('left', (leftPercentage - 100) + '%');
        nextSlide.css('left', leftPercentage + '%');
    } else {
        currentSlide.removeClass('current').addClass('prev');
        nextSlide.removeClass('next').addClass('current');
    }
    imageLazyLoading();
    updateButtonStatus(carousel);
}

function goPrevious(carousel) {
    const currentIndex = Math.max(carousel.find('.slide.current').index(), 1) + 1;
    const currentSlide = carousel.find('.slide:nth-child(' + currentIndex + ')');
    const nextSlide = carousel.find('.slide:nth-child(' + (currentIndex + 1) + ')');
    const previousSlide = carousel.find('.slide:nth-child(' + (currentIndex - 1) + ')');

    if (currentSlide.is('[style]')) {
        currentSlide.removeAttr('style');
        nextSlide.removeAttr('style');
    } else if (currentIndex > 2) {
        currentSlide.removeClass('current').addClass('next');
        previousSlide.removeClass('prev').addClass('current');
    }
    updateButtonStatus(carousel);
}

function updateButtonStatus(carousel) {
    const nextButton = carousel.find('.btn-next');
    const previousButton = carousel.find('.btn-prev');
    if (carousel.find('.slide').length === 1) {
        nextButton.addClass('disabled');
        previousButton.addClass('disabled');
        return;
    }

    const firstSlide = previousButton.next();
    const lastSlide = nextButton.prev();
    if (firstSlide.is('[style], .slide.prev')) {
        previousButton.removeClass('disabled');
    } else {
        previousButton.addClass('disabled');
    }

    if (lastSlide.is('[style], .slide.current')) {
        nextButton.addClass('disabled');
    } else {
        nextButton.removeClass('disabled');
    }
}

function toBangla(number) {
    const banglaNumbers = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
    if (number < 10) {
        return '' + banglaNumbers[0] + banglaNumbers[number];
    }
    let banglaNumber = '';
    number.toString().split('').forEach(num => {
        banglaNumber += banglaNumbers[Number(num)];
    });
    return banglaNumber;
}

const pageContext = $('meta[name=context-path]').attr('content');
const CSRF = $("meta[name='csrf-token']").attr('content');
const userId = $("meta[name='user-id']").attr('content');

const ratings = document.getElementById('js--home-rating')
const revRatings = document.getElementById('js--review-rating');
let rating = 0;

$('.expression .js-excellent, .expression .js-very-good, .expression .js-good, .expression .js-fair, .expression .js-poor').css('display', 'none');


$('#js--home-rating').delegate('i', 'click', function () {
    rating = $(this).attr("data-rating");
    $('i.ratings').each(function () {
        $(this).removeClass('ion-ios-star');
        $(this).addClass('ion-ios-star-outline');
    })
    for (let i = 0; i < rating; i++) {
        [...ratings.children][i].classList.remove('ion-ios-star-outline');
        [...ratings.children][i].classList.add('ion-ios-star');
    }
    if (rating == 5) {
        $('.js-excellent').fadeIn('slow').css('display', 'block');
        $('.expression .js-very-good, .expression .js-good, .expression .js-fair, .expression .js-poor').css('display', 'none');
    }
    if (rating == 4) {
        $('.js-very-good').fadeIn('slow').css('display', 'block');
        $('.expression .js-excellent, .expression .js-good, .expression .js-fair, .expression .js-poor').css('display', 'none');
    }
    if (rating == 3) {
        $('.js-good').fadeIn('slow').css('display', 'block');
        $('.expression .js-excellent, .expression .js-very-good, .expression .js-fair, .expression .js-poor').css('display', 'none');
    }
    if (rating == 2) {
        $('.js-fair').fadeIn('slow').css('display', 'block');
        $('.expression .js-excellent, .expression .js-very-good, .expression .js-good, .expression .js-poor').css('display', 'none');
    }
    if (rating == 1) {
        $('.js-poor').fadeIn('slow').css('display', 'block');
        $('.expression .js-excellent, .expression .js-very-good, .expression .js-good, .expression .js-fair').css('display', 'none');
    }
});

$('#js--review-rating').delegate('i', 'click', function () {
    rating = $(this).attr("data-rating");
    $('i.ratings').each(function () {
        $(this).removeClass('ion-ios-star');
        $(this).addClass('ion-ios-star-outline');
    })
    for (let i = 0; i < rating; i++) {
        [...revRatings.children][i].classList.remove('ion-ios-star-outline');
        [...revRatings.children][i].classList.add('ion-ios-star');
    }
});

//Hover Effect for rating
if (ratings) {
    [].forEach.call([...ratings.children], (( star, index ) => {
        star.addEventListener('mouseover', () => {

            for (let i = 0; i < 5; i++) {
                [...ratings.children][i].classList.remove('ion-ios-star');
                [...ratings.children][i].classList.add('ion-ios-star-outline');
            }

            for (let i = 0; i <= index; i++) {
                [...ratings.children][i].classList.remove('ion-ios-star-outline');
                [...ratings.children][i].classList.add('ion-ios-star');
            }
        })

        star.addEventListener('mouseleave', () => {
            for (let i = 0; i <= index; i++) {
                [...ratings.children][i].classList.remove('ion-ios-star');
                [...ratings.children][i].classList.add('ion-ios-star-outline');
            }
        })
    }))

    ratings.addEventListener('mouseleave', () => {
        if (rating > 0) {
            for (let i = 0; i < rating; i++) {
                [...ratings.children][i].classList.remove('ion-ios-star-outline');
                [...ratings.children][i].classList.add('ion-ios-star');
            }
        }
    })

    if (rating > 0) {
        for (let i = 0; i < rating; i++) {
            [...ratings.children][i].classList.remove('ion-ios-star-outline');
            [...ratings.children][i].classList.add('ion-ios-star');
        }
    }
}

 //Hover Effect for rating
 if (revRatings) {
    [].forEach.call([...revRatings.children], (( star, index ) => {
        star.addEventListener('mouseover', () => {

            for (let i = 0; i < 5; i++) {
                [...revRatings.children][i].classList.remove('ion-ios-star');
                [...revRatings.children][i].classList.add('ion-ios-star-outline');
            }

            for (let i = 0; i <= index; i++) {
                [...revRatings.children][i].classList.remove('ion-ios-star-outline');
                [...revRatings.children][i].classList.add('ion-ios-star');
            }
        })

        star.addEventListener('mouseleave', () => {
            for (let i = 0; i <= index; i++) {
                [...revRatings.children][i].classList.remove('ion-ios-star');
                [...revRatings.children][i].classList.add('ion-ios-star-outline');
            }
        })
    }))

    revRatings.addEventListener('mouseleave', () => {
        if (rating > 0) {
            for (let i = 0; i < rating; i++) {
                [...revRatings.children][i].classList.remove('ion-ios-star-outline');
                [...revRatings.children][i].classList.add('ion-ios-star');
            }
        }
    })

    if (rating > 0) {
        for (let i = 0; i < rating; i++) {
            [...revRatings.children][i].classList.remove('ion-ios-star-outline');
            [...revRatings.children][i].classList.add('ion-ios-star');
        }
    }
}

$('.rating-msg').css('display', 'none');

var curreantRatingForLastOrder = 0;
$('.ratings').click(function () {
    curreantRatingForLastOrder = parseInt($(this).data('rating'), 10);
});
$('.btn-rating_submit').click(function() {
    const lastOrderFeedbackMsg = $('#lastOrderFeedbackMsg').val();

    if(curreantRatingForLastOrder == 0) {
        alert('Please rate first.')
    } else {
        $.ajax({
            type: 'POST',
            url: pageContext + '/cust-order-feedback',
            data: 'point=' + curreantRatingForLastOrder + '&comment=' + lastOrderFeedbackMsg + '&orderId=' + $('#lastOrderId').val() + '&_tk=' + CSRF,
            success: function(response){
                if(response.result == true) {
                    $('.text-success').text(response.message);
                }
                else {
                    $('.text-success').text(response.message);
                }
                $('.rating-modal .rating-section').hide();
                $('.rating-msg').css('display', 'block');
            },
            error: function (error) {
                $('.rating-modal .rating-section').hide();
                $('.rating-msg').css('display', 'block');
            }
        });
    }
});

// START -  Writing review
    $('#js--write-review').click(function (e) {
        e.preventDefault();
        location.href = LOGIN_PAGE;
    });

    $('.js--review-rating-msg').css('display', 'none');

    $('#js--review-submit').click(function () {
        const PRODUCT_ID = $(this).data('id');
        const reviewMessageText = $('#js--review-message-text');
        const reviewMessageContainer = $('#js--message-review');
        const review = $('#js--review-writing').val();
        $('#js--review-writing').prop('required', true);

        if (!review.trim()) {
            reviewMessageText.html("Please write your valuable review below");
            reviewMessageContainer.slideDown();
        } else if (PRODUCT_ID && review && CSRF) {
            $.post(
                pageContext + "/writeuserreviewbyajax",
                "productId=" + PRODUCT_ID + "&review=" + review + "&source=POP_UP" + "&_tk=" + CSRF,
                function (message) {
                    $('.review-modal .review-section').hide();
                    $('.js--review-rating-msg p').html('Thank you for submitting your review.');
                    $('.js--review-rating-msg').css('display', 'block');
                }
            );
        }
    });


    $('#js--home-rating').delegate('i', 'click', function () {
        let PRODUCT_ID = $(this).parent().data('id');
        const rating = $(this).attr("data-rating");
        if (PRODUCT_ID && rating && CSRF) {
            $('i.ratings').each(function () {
                $(this).removeClass('ion-ios-star');
                $(this).addClass('ion-ios-star-outline');
            });
            for (let i = 0; i < rating; i++) {
                [...ratings.children][i].classList.remove('ion-ios-star-outline');
                [...ratings.children][i].classList.add('ion-ios-star');
            }
            $.ajax({
                type: "POST",
                url: pageContext + "/rate/" + PRODUCT_ID + "/" + rating,
                data: "&_tk=" + CSRF,
                success: function (response) {
                    reviewMessageText.html('Thank you for rating!');
                    reviewMessageContainer.slideDown();
                    showReview(PAGE_CONTEXT + REVIEW_PATH + PRODUCT_ID + "/", 1);
                }
            });
        }
    });

    $('#js--review-rating').delegate('i', 'click', function () {
        let PRODUCT_ID = $(this).parent().data('id');
        const rating = $(this).attr("data-rating");
        if (PRODUCT_ID && rating && CSRF) {
            $('i.ratings').each(function () {
                $(this).removeClass('ion-ios-star');
                $(this).addClass('ion-ios-star-outline');
            });
            for (let i = 0; i < rating; i++) {
                [...revRatings.children][i].classList.remove('ion-ios-star-outline');
                [...revRatings.children][i].classList.add('ion-ios-star');
            }
            $.ajax({
                type: "POST",
                url: pageContext + "/rate/" + PRODUCT_ID + "/" + rating,
                data: "&_tk=" + CSRF,
                success: function (response) {
                    reviewMessageText.html('Thank you for rating!');
                    reviewMessageContainer.slideDown();
                    showReview(PAGE_CONTEXT + REVIEW_PATH + PRODUCT_ID + "/", 1);
                }
            });
        }
    });
    // END -  Writing review


    // user favorite selection
    let selectedCategory = JSON.parse(getCookie('selectedCategory')) || [];

    renderCarousel(selectedCategory);
    if (selectedCategory) {
        $('.js--user-selection').each(function (e) {
            selectedCategory.forEach(category => {
                if ($(this).attr('data-id') == category.id) {
                    $(this).children('.js--user-select-check').show()
                }
            })
        })
    }
    
    $('.js--user-selection').on('click', function (e) {
        let productId = $(this).attr('data-id');
        let productCategory = $(this).find('.js--user-selection-caption').text();

        if (selectedCategory.length < 4) {
            $(this).children('.js--user-select-check').toggle();
        } else {
            $(this).children('.js--user-select-check').hide();
        }

        let display = $(this).children('.js--user-select-check').css('display');
        if (selectedCategory.findIndex(product => product.id == productId) < 0 && display == 'block' && selectedCategory.length < 4) {
            selectedCategory.unshift({
                id: productId,
                category: $.trim(productCategory.replace(/,/g, ' '))
            });
        } else if (selectedCategory.findIndex(product => product.id == productId) != -1 && display == 'none') {
           
            selectedCategory.splice(selectedCategory.findIndex(product => product.id == productId), 1)
        }
        
        setCookie('selectedCategory', JSON.stringify(selectedCategory), 7)
        renderCarousel(selectedCategory);
    });

    $('.js--user-select-slick').slick({
        slidesToShow: 5,
        lazyLoad: 'ondemand',
        infinite: false,
        slidesToScroll: 4,
        mobileFirst: true,
        arrows: true,
        cssEase: 'ease-out',
        useTransform: true,
        touchThreshold: 20,
        speed: 800,
        

        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 5,
                },
            },

            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 6,
                },
            },
        ],
	});

    //render book carousel
    function renderCarousel(products) {
        let html = '';
        if (products.length == 0) {
            $('.user-selection').next().html('');
        } else {
            products.forEach((product) => {
                $.ajax({
                    type: 'GET',
                    url: pageContext + `/book/category/get-front-list?categoryId=${product.id}`,
                    async: false,
                    success: (response) => {
                        html += `<section class="user-choice">`;
                        html += `<h4 class= 'user-choice__title'>${product.category}</h4>`;
                        html += `<div class="user-choice__content js--user-choice ">`;

                        response.productShortViews.forEach((list, index) => {
                            html += getProductHtml(list, "", 'ucs'+product.id);
                        });

                        html += '</div></section>';
                        $('.user-selection').next().html(html);
                    },
                });
            });

            $('.js--user-choice').slick({
                slidesToShow: 5,
                lazyLoad: 'ondemand',
                infinite: false,
                slidesToScroll: 4,
                mobileFirst: true,
                arrows: true,
                cssEase: 'ease-out',
                useTransform: true,
                touchThreshold: 20,
                speed: 800,

                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 5,
                        },
                    }
                ],
            });

            imageLazyLoading();
        }
    }

/* Handles the functionality of a "Load More" button on a home page. */
$(() => {
    const regex = /^\/book[;?A-Za-z0-9=]*$/;
    if(regex.test(location.pathname)) {
        let loadMoreLocked = false;
        let loadMoreEnd = false;
        const loadMoreButton = $('#js--load-more-btn');
        const section = loadMoreButton.closest('div');
        const lastPage = Number(loadMoreButton.attr('last-page'));

        if (loadMoreButton.length > 0) {
            $(document).on('scroll', () => {
                if (!loadMoreLocked && !loadMoreEnd && $(window).scrollTop() >= (loadMoreButton.offset().top - $(window).height())) {
                    loadMoreLocked = true;
                    const page = Number(loadMoreButton.attr('page'));
                    $.getJSON('/desktop/front-list?page=' + page, frontLists => {
                        homePageFrontLists = homePageFrontLists.concat(frontLists);
                        frontLists.forEach((frontList, frontListIndex) => $(getFrontListHtml(frontList, frontListIndex)).insertBefore(section));
                        imageLazyLoading();
                        if (page === lastPage) {
                            section.hide();
                            loadMoreEnd = true;
                            $('.js--book-list').slick('refresh');
                        } else {
                            loadMoreButton.attr('page', page + 1);
                        }
                        loadMoreLocked = false;
                    });
                }
            });
        }
    }
});

/*************************************
    Leaderboard Section Scripts
*************************************/

$(document).on('click', '#js--book-fair-leaderboard .slick-next', function () {
    $(this).hide();
});

$(document).on('click', '#js--book-fair-leaderboard .slick-prev', function () {
    $('#js--book-fair-leaderboard .slick-next').show();
});


// Fiction Filters

$('#fiction-author-tab').on('click', function () {
    $('#js--btn-view-all-fiction').attr('href', PAGE_CONTEXT + '/leaderboard/fiction?categoryId=' + $('#js--fiction-category').val() + `&filter=${$('#fiction-today-tab').hasClass('active') ? 'TODAY' : 'ALL'}&type=AUTHOR`);
    getData($('#js--fiction-category').val(), 'AUTHOR', $('#fiction-today-tab').hasClass('active') ? 'TODAY' : 'ALL', `${AUTHOR_IMAGE_URL}`, $('#fiction-today-tab').hasClass('active') ? $('#fiction-today') : $('#fiction-all'));
});

$('#fiction-book-tab').on('click', function () {
    $('#js--btn-view-all-fiction').attr('href', PAGE_CONTEXT + '/leaderboard/fiction?categoryId=' + $('#js--fiction-category').val() + `&filter=${$('#fiction-today-tab').hasClass('active') ? 'TODAY' : 'ALL'}&type=PRODUCT`);
    getData($('#js--fiction-category').val(), 'PRODUCT', $('#fiction-today-tab').hasClass('active') ? 'TODAY' : 'ALL', `${PRODUCT_IMAGE_URL}/130X186`, $('#fiction-today-tab').hasClass('active') ? $('#fiction-today') : $('#fiction-all'));
});

$('#js--fiction-category').on('change', function () {
    $('#js--btn-view-all-fiction').attr('href', PAGE_CONTEXT + '/leaderboard/fiction?categoryId=' + $(this).val() + `&filter=${$('#fiction-today-tab').hasClass('active') ? 'TODAY' : 'ALL'}&type=${$('#fiction-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR'}`);
    getData($(this).val(), $('#fiction-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR', $('#fiction-today-tab').hasClass('active') ? 'TODAY' : 'ALL', $('#fiction-book-tab').hasClass('active') ? `${PRODUCT_IMAGE_URL}/130X186` : `${AUTHOR_IMAGE_URL}`, $('#fiction-today-tab').hasClass('active') ? $('#fiction-today') : $('#fiction-all'));
});

$('#fiction-today-tab').on('click', function () {
    $('#js--btn-view-all-fiction').attr('href', PAGE_CONTEXT + '/leaderboard/fiction?categoryId=' + $('#js--fiction-category').val() + '&filter=TODAY' + `&type=${$('#fiction-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR'}`);
    getData($('#js--fiction-category').val(), $('#fiction-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR', 'TODAY', $('#fiction-book-tab').hasClass('active') ? `${PRODUCT_IMAGE_URL}/130X186` : `${AUTHOR_IMAGE_URL}`, $('#fiction-today'));
});

$('#fiction-all-tab').on('click', function () {
    $('#js--btn-view-all-fiction').attr('href', PAGE_CONTEXT + '/leaderboard/fiction?categoryId=' + $('#js--fiction-category').val() + '&filter=ALL' + `&type=${$('#fiction-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR'}`);
    getData($('#js--fiction-category').val(), $('#fiction-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR', 'ALL', $('#fiction-book-tab').hasClass('active') ? `${PRODUCT_IMAGE_URL}/130X186` : `${AUTHOR_IMAGE_URL}`, $('#fiction-all'));
});

// Non-Fiction Filters

$('#nonfiction-author-tab').on('click', function () {
    $('#js--btn-view-all-nonfiction').attr('href', PAGE_CONTEXT + '/leaderboard/nonfiction?categoryId=' + $('#js--nonfiction-category').val() + `&filter=${$('#nonfiction-today-tab').hasClass('active') ? 'TODAY' : 'ALL'}&type=AUTHOR`);
    getData($('#js--nonfiction-category').val(), 'AUTHOR', $('#nonfiction-today-tab').hasClass('active') ? 'TODAY' : 'ALL', `${AUTHOR_IMAGE_URL}`, $('#nonfiction-today-tab').hasClass('active') ? $('#nonfiction-today') : $('#nonfiction-all'));
});

$('#nonfiction-book-tab').on('click', function () {
    $('#js--btn-view-all-nonfiction').attr('href', PAGE_CONTEXT + '/leaderboard/nonfiction?categoryId=' + $('#js--nonfiction-category').val() + `&filter=${$('#nonfiction-today-tab').hasClass('active') ? 'TODAY' : 'ALL'}&type=PRODUCT`);
    getData($('#js--nonfiction-category').val(), 'PRODUCT', $('#nonfiction-today-tab').hasClass('active') ? 'TODAY' : 'ALL', `${PRODUCT_IMAGE_URL}/130X186`, $('#nonfiction-today-tab').hasClass('active') ? $('#nonfiction-today') : $('#nonfiction-all'));
});

$('#js--nonfiction-category').on('change', function () {
    $('#js--btn-view-all-nonfiction').attr('href', PAGE_CONTEXT + '/leaderboard/nonfiction?categoryId=' + $(this).val() + `&filter=${$('#nonfiction-today-tab').hasClass('active') ? 'TODAY' : 'ALL'}&type=${$('#nonfiction-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR'}`);
    getData($(this).val(), $('#nonfiction-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR', $('#nonfiction-today-tab').hasClass('active') ? 'TODAY' : 'ALL', $('#nonfiction-book-tab').hasClass('active') ? `${PRODUCT_IMAGE_URL}/130X186` : `${AUTHOR_IMAGE_URL}`, $('#nonfiction-today-tab').hasClass('active') ? $('#nonfiction-today') : $('#nonfiction-all'));
});

$('#nonfiction-today-tab').on('click', function () {
    $('#js--btn-view-all-nonfiction').attr('href', PAGE_CONTEXT + '/leaderboard/nonfiction?categoryId=' + $('#js--nonfiction-category').val() + '&filter=TODAY' + `&type=${$('#nonfiction-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR'}`);
    getData($('#js--nonfiction-category').val(), $('#nonfiction-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR', 'TODAY', $('#nonfiction-book-tab').hasClass('active') ? `${PRODUCT_IMAGE_URL}/130X186` : `${AUTHOR_IMAGE_URL}`, $('#nonfiction-today'));
});

$('#nonfiction-all-tab').on('click', function () {
    $('#js--btn-view-all-nonfiction').attr('href', PAGE_CONTEXT + '/leaderboard/nonfiction?categoryId=' + $('#js--nonfiction-category').val() + '&filter=ALL' + `&type=${$('#nonfiction-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR'}`);
    getData($('#js--nonfiction-category').val(), $('#nonfiction-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR', 'ALL', $('#nonfiction-book-tab').hasClass('active') ? `${PRODUCT_IMAGE_URL}/130X186` : `${AUTHOR_IMAGE_URL}`, $('#nonfiction-all'));
});

// Dhormio Filters

$('#dhormio-author-tab').on('click', function () {
    $('#js--btn-view-all-dhormio').attr('href', PAGE_CONTEXT + '/leaderboard/dhormio?categoryId=' + $('#js--dhormio-category').val() + `&filter=${$('#dhormio-today-tab').hasClass('active') ? 'TODAY' : 'ALL'}&type=AUTHOR`);
    getData($('#js--dhormio-category').val(), 'AUTHOR', $('#dhormio-today-tab').hasClass('active') ? 'TODAY' : 'ALL', `${AUTHOR_IMAGE_URL}`, $('#dhormio-today-tab').hasClass('active') ? $('#dhormio-today') : $('#dhormio-all'));
});

$('#dhormio-book-tab').on('click', function () {
    $('#js--btn-view-all-dhormio').attr('href', PAGE_CONTEXT + '/leaderboard/dhormio?categoryId=' + $('#js--dhormio-category').val() + `&filter=${$('#dhormio-today-tab').hasClass('active') ? 'TODAY' : 'ALL'}&type=PRODUCT`);
    getData($('#js--dhormio-category').val(), 'PRODUCT', $('#dhormio-today-tab').hasClass('active') ? 'TODAY' : 'ALL', `${PRODUCT_IMAGE_URL}/130X186`, $('#dhormio-today-tab').hasClass('active') ? $('#dhormio-today') : $('#dhormio-all'));
});

$('#js--dhormio-category').on('change', function () {
    $('#js--btn-view-all-dhormio').attr('href', PAGE_CONTEXT + '/leaderboard/dhormio?categoryId=' + $(this).val() + `&filter=${$('#dhormio-today-tab').hasClass('active') ? 'TODAY' : 'ALL'}&type=${$('#dhormio-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR'}`);
    getData($(this).val(), $('#dhormio-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR', $('#dhormio-today-tab').hasClass('active') ? 'TODAY' : 'ALL', $('#dhormio-book-tab').hasClass('active') ? `${PRODUCT_IMAGE_URL}/130X186` : `${AUTHOR_IMAGE_URL}`, $('#dhormio-today-tab').hasClass('active') ? $('#dhormio-today') : $('#dhormio-all'));
});

$('#dhormio-today-tab').on('click', function () {
    $('#js--btn-view-all-dhormio').attr('href', PAGE_CONTEXT + '/leaderboard/dhormio?categoryId=' + $('#js--dhormio-category').val() + '&filter=TODAY' + `&type=${$('#dhormio-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR'}`);
    getData($('#js--dhormio-category').val(), $('#dhormio-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR', 'TODAY', $('#dhormio-book-tab').hasClass('active') ? `${PRODUCT_IMAGE_URL}/130X186` : `${AUTHOR_IMAGE_URL}`, $('#dhormio-today'));
});

$('#dhormio-all-tab').on('click', function () {
    $('#js--btn-view-all-dhormio').attr('href', PAGE_CONTEXT + '/leaderboard/dhormio?categoryId=' + $('#js--dhormio-category').val() + '&filter=ALL' + `&type=${$('#dhormio-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR'}`);
    getData($('#js--dhormio-category').val(), $('#dhormio-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR', 'ALL', $('#dhormio-book-tab').hasClass('active') ? `${PRODUCT_IMAGE_URL}/130X186` : `${AUTHOR_IMAGE_URL}`, $('#dhormio-all'));
});

// Career Filters

$('#career-author-tab').on('click', function () {
    $('#js--btn-view-all-career').attr('href', PAGE_CONTEXT + '/leaderboard/career?categoryId=' + $('#js--career-category').val() + `&filter=${$('#career-today-tab').hasClass('active') ? 'TODAY' : 'ALL'}&type=AUTHOR`);
    getData($('#js--career-category').val(), 'AUTHOR', $('#career-today-tab').hasClass('active') ? 'TODAY' : 'ALL', `${AUTHOR_IMAGE_URL}`, $('#career-today-tab').hasClass('active') ? $('#career-today') : $('#career-all'));
});

$('#career-book-tab').on('click', function () {
    $('#js--btn-view-all-career').attr('href', PAGE_CONTEXT + '/leaderboard/career?categoryId=' + $('#js--career-category').val() + `&filter=${$('#career-today-tab').hasClass('active') ? 'TODAY' : 'ALL'}&type=PRODUCT`);
    getData($('#js--career-category').val(), 'PRODUCT', $('#career-today-tab').hasClass('active') ? 'TODAY' : 'ALL', `${PRODUCT_IMAGE_URL}/130X186`, $('#career-today-tab').hasClass('active') ? $('#career-today') : $('#career-all'));
});

$('#js--career-category').on('change', function () {
    $('#js--btn-view-all-career').attr('href', PAGE_CONTEXT + '/leaderboard/career?categoryId=' + $(this).val() + `&filter=${$('#career-today-tab').hasClass('active') ? 'TODAY' : 'ALL'}&type=${$('#career-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR'}`);
    getData($(this).val(), $('#career-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR', $('#career-today-tab').hasClass('active') ? 'TODAY' : 'ALL', $('#career-book-tab').hasClass('active') ? `${PRODUCT_IMAGE_URL}/130X186` : `${AUTHOR_IMAGE_URL}`, $('#career-today-tab').hasClass('active') ? $('#career-today') : $('#career-all'));
});

$('#career-today-tab').on('click', function () {
    $('#js--btn-view-all-career').attr('href', PAGE_CONTEXT + '/leaderboard/career?categoryId=' + $('#js--career-category').val() + '&filter=TODAY' + `&type=${$('#career-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR'}`);
    getData($('#js--career-category').val(), $('#career-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR', 'TODAY', $('#career-book-tab').hasClass('active') ? `${PRODUCT_IMAGE_URL}/130X186` : `${AUTHOR_IMAGE_URL}`, $('#career-today'));
});

$('#career-all-tab').on('click', function () {
    $('#js--btn-view-all-career').attr('href', PAGE_CONTEXT + '/leaderboard/career?categoryId=' + $('#js--career-category').val() + '&filter=ALL' + `&type=${$('#career-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR'}`);
    getData($('#js--career-category').val(), $('#career-book-tab').hasClass('active') ? 'PRODUCT' : 'AUTHOR', 'ALL', $('#career-book-tab').hasClass('active') ? `${PRODUCT_IMAGE_URL}/130X186` : `${AUTHOR_IMAGE_URL}`, $('#career-all'));
});

// Company Filters

$('#best-publisher-today-tab').on('click', function () {
    $('#js--btn-view-all-publisher').attr('href', PAGE_CONTEXT + '/leaderboard/company?filter=TODAY');
    getData(0, 'COMPANY', 'TODAY', PUBLISHER_IMAGE_URL, $('#best-publisher-today'));
});

$('#best-publisher-all-tab').on('click', function () {
    $('#js--btn-view-all-publisher').attr('href', PAGE_CONTEXT + '/leaderboard/company?filter=ALL');
    getData(0, 'COMPANY', 'ALL', PUBLISHER_IMAGE_URL, $('#best-publisher-all'));
});

function getData(id, type, filterType, imageUrl, element) {
    $.ajax({
        url: `/leaderboard/data?type=${type}&category=${id}&filter=${filterType}`,
        success: function(result) {
            let html = '';
            let name = type == 'AUTHOR' ? 'book/author' : type == 'COMPANY' ? 'publisher' : 'book';

            element.html('');

            result.slice(0, 6).map((item, index) => {
                let htmlStar = '';
                let averageRating = item.averageRating;
                let fullStar = Math.floor(averageRating);
                let halfStar = (averageRating % 1 != 0 ? 1 : 0);
                let emptyStar = 5 - fullStar - halfStar;

                if (averageRating > 0) {
                    for (let i = 0; i < fullStar; i++) {
                        htmlStar += '<i class="ion-ios-star"></i>';
                    }
                    for (let i = 0; i < halfStar; i++) {
                        htmlStar += '<i class="ion-ios-star-half"></i>';
                    }
                    for (let i = 0; i < emptyStar; i++) {
                        htmlStar += '<i class="ion-ios-star-outline"></i>';
                    }
                }

                html = `
                    <a href="${PAGE_CONTEXT}/${name}/${item.id}" class="item-info">
                        <h4 class="index">${index+1}.</h4>
                        <img src="${imageUrl}/${item.image}" alt="${item.image}" class="item-img ${type === 'AUTHOR' || type === 'COMPANY' ? 'rounded-circle' : ''}" />
                        <div class="item-desc">
                            <p class="title">${item.title}</p>
                            ${type !== 'AUTHOR' ? `<p class="subtitle">${item.subtitle}</p>` : ''}
                            ${(type !== 'AUTHOR' && averageRating > 0) ? `<div class="rating-section">${htmlStar} <span class="text-secondary">(${item.numberOfRating})</span></div>` : ''}
                        </div>
                        ${item.ranking < item.previousRanking ? `<img src="${IMG_FILE_PATH}/icon_up.png" alt="icon_up" class="growth-status ml-auto" />` : ''}
                        ${item.ranking > item.previousRanking ? `<img src="${IMG_FILE_PATH}/icon_down.png" alt="icon_down" class="growth-status ml-auto" />` : ''}
                        ${item.ranking == item.previousRanking ? `<p class="mb-0 ml-auto"><i class="ion-minus-round text-secondary"></i></p>` : ''}
                    </a>
                `;

                element.append(html);
            });
        }
    });
}

function superDealSectionMaker(dealFrontList) {
    let data = `
        <div class="superdeal-browse__body">
            <div class="superdeal-top">
                <div class="superdeal-timer">
                    <p class="superdeal-name">${dealFrontList.title}</p>
                    <p class="title">Ends in </p>
                    <p class="countdown" id="js--countdown" data-end-date="${new Date(dealFrontList.visibleEndTime)}">
                        <span class="countdown-box" id="js--hour-timer">00</span> :
                        <span class="countdown-box" id="js--minute-timer">00</span> :
                        <span class="countdown-box" id="js--second-timer">00</span>
                    </p>
                </div>

                <a href="/super-deal" class="btn btn-outline-secondary list-btn view-all-btn">Shop More</a>
            </div>

            <div class="superdeal-products__container">
                <div class="superdeal-products__container__grid ${dealFrontList.productShortViews.length < 7 ? '' : 'js--super-deal js--lazy-loading'} justify-content-start">
                    ${dealFrontList.productShortViews.map((product, index) => getDealProductHtml(product, 0, `hd_d_p${index}`, true)).join('')}
                </div>
            </div>
        </div>
    `
    
    return data;
}

function userChoiceSectionMaker(frontList, id) {
    let data = `
            <section class="home-book-list-section" id="js--user-choice-${id}">
            <div class="row">
                <div class="col-8 d-flex align-items-center">
                    <h3 class="home-book-list-title">${frontList.title}</h3>
                </div>
                <div class="col-4">
                    <a href="${frontList.link}"
                        class="btn btn-outline-secondary list-btn float-right">View All</a>
                </div>
            </div>
            <div class="home-book-list__content js--user-choice-FLs-${id}">
                ${frontList.productShortViews.map((product, index) => getProductHtml(product, 0, `usr-cd-${id}-${index}`, true)).join('')}
            </div>
        </section>
    `

    return data;
}


/**
 * See all superstore categories
 */
$('#js--btn-superstore-see-all').on('click', function() {
    $(this).hide();
    $('#js--superstore-category a').fadeIn();
});

$(document).ready( function() {
    const regex = /^\/book[;?A-Za-z0-9=]*$/;
    if(regex.test(location.pathname) && userId) {

        const isModelB = $('#js--recom-is-show-model-b').val() == 'true' ? true : false;
        
        $.get(`/product/recommendation-model-front-list?model=${isModelB ? 'v2' : 'v1'}`, function(res) {
            if(!res?.activeStatus || !res?.productShortViews.length) {
                return;
            }
            
            if(res?.productShortViews.length > 10) {
                for (let i = 0; i < 10; i++) {
                    $('#js--home-recommendation-section').append(`
                    <a class="single-recommendation" href="/book/${res.productShortViews[i].id}">
                        <img src="${PRODUCT_IMAGE_URL}/130X186/${res.productShortViews[i].avatar}" />
                    </a>
                `);
                }

                $('#js--home-recommendation-section-parent').removeClass('d-none');
            }

        });
    }
});

$(document).ready( function() {
    const regex = /^\/book[;?A-Za-z0-9=]*$/;
    if(regex.test(location.pathname)) {

        /* Reels of Deals Start */
        $.get('/product/deal-front-list', function(products) {
            if(!products?.productShortViews?.length ) {
                return;
            }
                
            const dealSection = superDealSectionMaker(products);

            $('#superdeal-section').append(dealSection)
            superDealCountDownTimer();
            slickAdd('js--super-deal');
            
            $('#superdeal-section').removeClass('d-none');
            $('.superdeal-products__container .slick-slider').slick('refresh');
        });
        /* Reels of Deals End */
    }
});

$(function() {
    const regex = /^\/book[;?A-Za-z0-9=]*$/;
    if(regex.test(location.pathname) && $('#js--user-choice-container').length) {

        /* user choice section start */
        $.get('/user-choice/category-front-list', function(choiceLists) {
            if(!choiceLists?.length) {
                return;
            }

            for(let choiceList = 0; choiceList < choiceLists.length; choiceList++) {
                if(choiceLists[choiceList]?.productShortViews?.length == 0) {
                    continue;
                }
                const choiceSection = userChoiceSectionMaker(choiceLists[choiceList], choiceList+1);
                $('#js--user-choice-container').append(choiceSection);

                if(choiceLists[choiceList]?.productShortViews?.length <= 6) {
                    $(`.js--user-choice-FLs-${choiceList+1}`).css('display', 'flex');
                } else {
                    slickAdd(`js--user-choice-FLs-${choiceList+1}`);
                }
            }

            $('#js--user-choice-container').removeClass('d-none');
        });
    }
});

function loadPrimaryCategories(apiCalledFrom){
    return $.ajax({
        type: 'GET',
        url: `/my-section/user-choice/${apiCalledFrom == 'HOME' ? '' : 'selected-'}primary-categories`,
        success: function (res) {
            if (res){
                const listsParent = $('.category-list');
                listsParent.empty();
                listsParent.append(res.categoryNames.map((categoryName, index)=> {
                    let isUserSelected = res.selectedCategories.includes(res.categoryIds[index]);
                    return `<button class="single-category text-truncate ${isUserSelected ? 'user-selected' : ''}" data-categoryId="${res.categoryIds[index]}">${categoryName}</button>`
                }));
            }
        }
    });
}

function loadSecondaryCategories(primaryCategoryIdList, apiCalledFrom){
    $.get(`/my-section/user-choice/${apiCalledFrom == "HOME" ? '' : 'selected-'}secondary-categories?categoryIds=${primaryCategoryIdList}`, function(res){
        if (res){
            const selectedCategoryNameParentContainer = $('.selected-categories');
            const subCategoryListParentContainer = $('.subcategory-list');
            $(selectedCategoryNameParentContainer).empty()
            $(subCategoryListParentContainer).empty()
            selectedCategoryNameParentContainer.append(res.responseDTOS.map(el =>
                `<div class="category text-truncate">
                    <i class="ion-checkmark-round"></i>
                    <p class='text-truncate'>${el.categoryName}</p>
                </div>`
            ));
            res.responseDTOS.forEach(categories => {
                subCategoryListParentContainer.append(categories.categoryNames.map((categoryName, index) => {
                    let isUserSelected = categories.selectedCategories.includes(categories.categoryIds[index]);
                    return `<div class="subcategory ${isUserSelected ? 'subcategory-user-select' : ''}" data-primaryCategoryId=${categories.categoryId} data-subCategoryId=${categories.categoryIds[index]}>
                        <i class="ion-ios-circle-outline check-circle"></i>
                        <i class="ion-checkmark-circled check-circle"></i>
                        <img src="${categories.imageUrls[index]}" alt="">
                        <p class='text-truncate'>${categoryName}</p>
                    </div>`}
                ));
            })

            $('.selected-categories').removeClass('slick-initialized slick-slider');
            if(res.responseDTOS.length > 3) {
                $(selectedCategoryNameParentContainer).slick({
                    slidesToShow: 3.5,
                    lazyLoad: 'ondemand',
                    infinite: false,
                    slidesToScroll: 2,
                    mobileFirst: true,
                    arrows: false,
                    cssEase: 'ease-out',
                    useTransform: true,
                    touchThreshold: 20,
                    speed: 800,
                });
            }

        }
    });
}

function showUserChoicePopup () {
    $('#js--menu-tooltip').hide();
    $('#js--user-choice-cateogory-modal').show();
    $('#js--user-choice-category-overlay').show();
}

function hideUserChoicePopup (hideSpeed=0) {
    if(hideSpeed == 1) {
        $('#js--user-choice-cateogory-modal').hide('slow');
    } else {
        $('#js--user-choice-cateogory-modal').hide();
    }
    $('#js--menu-tooltip').show();
    $('#js--user-choice-category-overlay').hide();
}

// user choice get book categories and non book categories
$(async function(){
    const regex = /^\/book[;?A-Za-z0-9=]*$/;
    const lastTimeOrSkipped = localStorage.getItem('usrlt');

    if(lastTimeOrSkipped == 0) {
        return;
    }

    if (regex.test(location.pathname) && (!lastTimeOrSkipped || (Date.now()  > lastTimeOrSkipped)) && $('#js--user-choice-cateogory-modal').length ){
        try {
            const apiCalledFrom = $('#js--user-choice-cateogory-modal').attr('data-modalFrom');
            await loadPrimaryCategories(apiCalledFrom);
            showUserChoicePopup();
            if($('#js--user-choice-cateogory-modal').attr('data-modalfrom') == 'HOME') {
                localStorage.setItem('usrlt', Date.now() + 24 * 60 * 60 * 1000);
            }
        } catch (err) {}
    }
})

$('#js--skip-user-choice-modal').on('click', function() {
    localStorage.setItem('usrlt', 0);
    hideUserChoicePopup();
})

$('#js--user-choice-close-btn').on('click', function() {
    hideUserChoicePopup();
})

function btnMessageAndAction(isEnable, message, divId) {
    if(isEnable) {
        $(divId).addClass('enabled');
    } else {
        $(divId).removeClass('enabled');
    }
    $(divId).prop("disabled", !isEnable);
    $(divId).text(message);
}

// single category item clicked
$(document).on('click', '.single-category', function(e){
    let selectSize = $('.user-selected').length;

    if (!$(this).hasClass('user-selected') && selectSize <= 4) {
        $(this).addClass('user-selected');
        selectSize++;
    }else{
        $(this).removeClass('user-selected');
        selectSize--;
    }

    if(selectSize >= 3) {
        btnMessageAndAction(true, 'পরবর্তী', '#js--user-choice-next-subcategory-btn');
    } else if(selectSize < 3) {
        btnMessageAndAction(false, 'সর্বনিম্ন ৩টি এবং সর্বোচ্চ ৫টি বাছাই করুন', '#js--user-choice-next-subcategory-btn');
    }
})

$(document).on('click', '.subcategory', function(e) {
    let selectSize = $('.subcategory-user-select').length;

    if (!$(this).hasClass('subcategory-user-select')) {
        $(this).addClass('subcategory-user-select');
        selectSize++;
    }else{
        $(this).removeClass('subcategory-user-select');
        selectSize--;
    }

    if(selectSize >= 5) {
        btnMessageAndAction(true, 'সাবমিট করুন', '#js--user-choice-submit-btn');
    } else if(selectSize < 5) {
        btnMessageAndAction(false, 'সর্বনিম্ন ৫টি বাছাই করুন', '#js--user-choice-submit-btn');
    }
})

$('#js--user-choice-submit-btn').on('click', function () {
    let categoryMap  = {}
    $('.subcategory-user-select').each((ind, el) => {
        const {primarycategoryid, subcategoryid} = $(el).data();
        if(!categoryMap [`${primarycategoryid}`]) {
            categoryMap [`${primarycategoryid}`] = [];
        }
        categoryMap [`${primarycategoryid}`].push(subcategoryid);
    })
    let userChoiceRequestDTO = [];
    for (let parentCategoryId in categoryMap) {
        userChoiceRequestDTO.push({
            parentCategoryId: parseInt(parentCategoryId),
            childCategoryIds: categoryMap[parentCategoryId]
        });
    }
    $.ajax({
        type: 'POST',
        contentType: 'application/json',
        url: '/my-section/user-choice/set-categories?_tk=' + CSRF,
        data: JSON.stringify(userChoiceRequestDTO),
        success: function (res) {
            $('#js--go-back').hide();
            $('#js--user-choice-main-body').hide();
            $('#js--user-success-container').show();
            setTimeout(() => {
                hideUserChoicePopup(1);
                location.reload();
            }, 2500)
        },
        error: function (res) {
            $('#js--go-back').hide();
            $('#js--user-choice-main-body').hide();
            $('#js--user-fail-container').show();
            setTimeout(() => {
                hideUserChoicePopup(1);
            }, 2500)
        }
    });
})

$('#js--user-choice-next-subcategory-btn').on('click', function () {
    let categoryIdList = []
    $('.user-selected').each((ind, el) => {
        const id = $(el).data('categoryid');
        categoryIdList.push(+id);
    })
    const apiCalledFrom = $('#js--user-choice-cateogory-modal').attr('data-modalFrom');
    loadSecondaryCategories(categoryIdList, apiCalledFrom);
    $(this).attr('disabled', true).removeClass('enabled');
    $(this).text('সর্বনিম্ন ৩টি এবং সর্বোচ্চ ৫টি বাছাই করুন');
    $(this).hide();
    btnMessageAndAction(false, 'সর্বনিম্ন ৫টি বাছাই করুন', '#js--user-choice-submit-btn');
    $('#js--user-choice-submit-btn').show();
    $('.subcategory-list-container').show();
    $('.category-list').hide();
    $('#js--skip-user-choice-modal').hide();
    $('#js--go-back').show();
})

$('#js--go-back').on('click', function() {
    $('.subcategory-list-container').hide();
    $('.category-list').show();
    $('#js--go-back').hide();
    $('#js--user-choice-next-subcategory-btn').show();
    $('#js--user-choice-submit-btn').hide();
    $('#js--skip-user-choice-modal').show();
})

// ab test home page recommendation
$(document).on('click', '.js--abtest-home-page-recommendation', function(){
    $.ajax({
        type: 'GET',
        url: '/ab-test/result/home/recommendation',
    });
})